module.exports = __webpack_public_path__ + "img/mIndex.d23492be.png";